import React from 'react';
import { connect } from 'react-redux';

import { DatePicker } from 'redpoints-front-components/index';
import { getDefaultDateRanges } from 'redpoints-front-common/helpers';

import { allIncidentsFiltersSetDetectionDate } from '../../../actions/allIncidentsActions';
import { getAllIncidentsFiltersDetectionDate } from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersDetectionDate = ({
  allIncidentsFiltersSetDetectionDate,
  detectionDate,
}) => {
  const handlerSetDetectionDate = detectionDate =>
    allIncidentsFiltersSetDetectionDate({ detectionDate });

  return (
    <DatePicker
      label={translate('reporting.allIncidentsInternal.filters.detectionDate')}
      onChange={handlerSetDetectionDate}
      ranges={getDefaultDateRanges()}
      rangePicker
      value={detectionDate || undefined}
    />
  );
};

const mapStateToProps = state => {
  return {
    detectionDate: getAllIncidentsFiltersDetectionDate(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetDetectionDate,
})(AllIncidentsFiltersDetectionDate);
